/** Rutas públicas de assets de marca Canto del Nabo */
export const LOGO_SVG = '/logo.svg';
export const MASCOT_PNG = '/rock-turnip.png';
/** Logo principal en UI: nabo rockero */
export const BRAND_LOGO = MASCOT_PNG;
export const DEFAULT_BRAND_NAME = 'Canto del Nabo';

/** Colores por defecto (paleta neón nocturno) */
export const DEFAULT_BRAND_COLORS = {
  color_primario: '#38bdf8',
  color_secundario: '#94a3b8',
  color_accent: '#fb923c',
  color_darkest: '#0a0f1a',
} as const;
